import { lazy } from 'react';
import modules from '@src/service/modules';

const Configuration = lazy(() => import('../../views/Settings/Configuration/index'));
const Emailconfig = lazy(() => import('../../views/Settings/Configuration/components/EmailConfig'));

const SettingsRoutes = [
    {
        path: '/settings/configuration',
        element: <Configuration />
        // dbId: modules.setup_user
    },
    {
        path: '/settings/configuration/email-config',
        element: <Emailconfig />
        // dbId: modules.setup_user_add
    }
];

export default SettingsRoutes;
